import { useStoreUser } from '~/providers/StoreUserProvider';

/**
 * Extracts the `currencyCode` and `currencySymbol` from the current `storeUser` found in the `MerchantContext`.
 */
export function useCurrency() {
  const {
    store: { currencyCode, currencySymbol },
  } = useStoreUser();

  return { currencyCode, currencySymbol };
}
